import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pickupTruckFilled"
const PickupTruckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 15C7.036 15 7.875 15.84 7.875 16.875S7.035 18.75 6 18.75 4.125 17.91 4.125 16.875 4.965 15 6 15M17.625 15C18.66 15 19.5 15.84 19.5 16.875S18.66 18.75 17.625 18.75 15.75 17.91 15.75 16.875 16.59 15 17.625 15" />
          <path d="M9.375 17.438H8.563Q8.624 17.165 8.625 16.875C8.625 15.425 7.45 14.25 6 14.25 4.553 14.25 3.38 15.42 3.375 16.867L2.801 16.779C2.16 16.68 1.687 16.13 1.687 15.481V15H2.25C2.56 15 2.813 14.748 2.813 14.438S2.56 13.875 2.25 13.875H1.688V12.75C1.688 12.025 2.274 11.438 3 11.438H9.375z" />
          <path
            fillRule="evenodd"
            d="M15.004 8.813C16.362 8.813 17.624 9.513 18.344 10.663L19.083 11.85 21.164 12.11C21.819 12.192 22.313 12.75 22.313 13.412V13.875H21.375C21.065 13.875 20.813 14.127 20.813 14.438S21.064 15 21.375 15H22.313V16.125C22.313 16.85 21.725 17.438 21 17.438H20.189Q20.249 17.165 20.25 16.875C20.25 15.425 19.075 14.25 17.625 14.25S15 15.425 15 16.875Q15.001 17.165 15.062 17.438H10.125V8.813zM12.938 10.875C12.938 11.393 13.358 11.813 13.875 11.813H14.063V9.937H12.937zM15.188 11.813H17.735L17.389 11.259C16.908 10.49 16.087 10.003 15.188 9.943z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PickupTruckFilledIcon
